<template>
	<div class="con">
		<div class="con-text" v-for="(item,index) in list" @click="consulting(index)">
			<div class="list-left">
				<img v-if="item.fromUserHeadImgUrl != ''" :src="item.fromUserHeadImgUrl" />
				<img v-else src="../assets/charUser.png" />
				<div class="num" v-if="item.num != ''">{{item.num}}</div>
			</div>
			<div class="list-right">
				<div class="list-top">
					<div class="name">{{item.fromUserName}}</div>
					<div>{{item.time}}</div>
				</div>
				<div class="questions">{{item.content}}</div>
			</div>
		</div>
		<div class="noImg" v-if="noImgShow == false">
			<img src="../assets/404.gif" />
			<div class="no-text">没有记录~</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'chatMessage',
		data() {
			return {
				list: [],
				emUserInfo: JSON.parse(localStorage.getItem('emUserInfo')),
				cardUserInfo: '',
				noImgShow: true,
				type: 0,//0是医生查询 1是病人查询
			}
		},
		methods: {
			//咨询
			consulting(e) {
				let data;
				if(Number(this.type) == 0){
					data = this.list[e];
					this.$router.push({
						path: '/chatRoom',
						query: {
							questions: JSON.stringify(data)
						}
					})
				}else{
					data = this.list[e];
					this.$router.push({
						path: '/chatRoom',
						query: {
							doctor: JSON.stringify(data)
						}
					})
				}
			},
			//查询记录
			GetPersonWech() {
				this.$store.commit('Load', true)
				let URL;
				if(Number(this.type) == 1){
					URL = '/chats/getHomePage?pageSize=10&currPage=1&toUserId=' + this.cardUserInfo.brid + '&toUserIdZ=' + this.cardUserInfo.bahm + '&toUserType=0';
				}else{
					URL = '/chats/getHomePage?pageSize=10&currPage=1&toUserId=' + this.emUserInfo.userId + '&toUserIdZ=' + '&toUserType=1';
				}
				this.$Axios.Get(URL,
					null).then(res => {
					console.log(res)
					this.$store.commit('Load', false)
					if (res.code == 0) {
						if (res.msg.list.length != 0) {
							this.noImgShow = true;
							let dataList = res.msg.list;
							for (let i = 0, len = dataList.length; i < len; i++) {
								let imgIf = dataList[i].content.split('img');
								if (imgIf[0] == '<') {
									dataList[i].content = '[图片]';
								}
							}
							this.list = dataList;
						} else {
							this.noImgShow = false;
						}

					} else {
						this.noImgShow = false;
					}
				}).catch(err => {
					this.$store.commit('Load', false)
					this.noImgShow = false;
					console.log(err)
				})
			},
		},
		mounted() {
			console.log()
			if(Number(this.$route.query.type) == 1){//病人查看谁给我发的消息
				this.type = Number(this.$route.query.type)
			}else{
				if (this.emUserInfo == null) {
					this.emUserInfo = {
						userId: ''
					}
				}
			}
			if (localStorage.getItem('cardUserInfo') != undefined && localStorage.getItem('cardUserInfo') != '') {
				this.cardUserInfo = JSON.parse(localStorage.getItem('cardUserInfo'))
			}
			this.GetPersonWech();
		},
		created() {
			
		},
	}
</script>

<style scoped>
	.con-text {
		display: flex;
		align-items: center;
		margin: 0 5px;
		padding: 10px;
		border-bottom: 1px solid #ccc;
		background-color: #fff;
	}

	.con-text img {
		width: 50px;
		height: 50px;
	}

	.list-left {
		position: relative;
	}

	.num {
		position: absolute;
		top: 0;
		right: 0;
		padding: 2px;
		text-align: center;
		color: #fff;
		background-color: red;
		border-radius: 5px;
		font-size: 12px;
	}

	.list-right {
		margin-left: 10px;
		width: 80%;
	}

	.list-top {
		display: flex;
		justify-content: space-between;
		align-items: center;
		font-size: 12px;
		color: #999;
	}

	.name {
		color: #000000;
		font-weight: 600;
		font-size: 15px;
	}

	.questions {
		margin-top: 5px;
		font-size: 14px;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	.noImg {
		margin-top: 10vh;
		text-align: center;
	}

	.no-text {
		margin-top: 10px;
		color: #27BEC4;
		font-size: 16px;

	}
</style>
